import React, { useState } from "react";
import useAxiosInstance from "../../hooks/useAxios";
import { toast } from "react-toastify";
import FormRender from "../../components/FormRender";
import { ENGLISH_TRANSLATOR_FORM_SETTINGS } from "../../helper";

// const FILE_TYPE_META = {
//   lexical: {
//     label: "Lexical file",
//     ext: "lexical",
//   },
//   docx: {
//     label: "DOCX",
//     ext: "docx",
//   },
//   ppt: {    
//     label: "PPT",
//     ext: "pptx",
//   },
// };

const EnglishTranslator = () => {
  const axiosInstance = useAxiosInstance();
  const [formData, setFormData] = useState({ report_id: "" });
  const [isDownloading, setIsDownloading] = useState(false);

  const handleDownload = async () => {
    if (!formData?.report_id) {
      toast.info("Please provide report id");
      return;
    }
    try {
      setIsDownloading(true);
      const response = await axiosInstance.post(
        "accounts/reverse_translation/",
        { report_id: formData.report_id },
        { responseType: "blob" }
      );

      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement('a');
      const safeId = String(formData.report_id).trim();
      link.href = url;
      link.setAttribute('download', `english_translator_${safeId}.docx`);
      document.body.appendChild(link);
      link.click();
      
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
      
      toast.success("Download completed successfully!");
    } catch (err) {
      console.error("Download error:", err);
      toast.error("Download failed");
    } finally {
      setIsDownloading(false);
    }
  };

  return (
    <div className="h-screen overflow-y-auto mr-2">
      <div className="p-4 my-4 border rounded-lg bg-white w-full">
        <p className="text-2xl text-black font-medium mb-4">English Translator</p>
        <div className="rounded-xl bg-gray-100 p-3">
          <FormRender
            formData={formData}
            formSettings={ENGLISH_TRANSLATOR_FORM_SETTINGS}
            setFormData={setFormData}
          />
          <div className="flex items-end mt-4">
            <button
              onClick={handleDownload}
              disabled={isDownloading || !formData?.report_id}
              className="px-4 py-2 h-[42px] disabled:bg-gray-300 bg-black rounded-lg text-white font-semibold"
            >
              {isDownloading ? "Downloading..." : "Download"}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default EnglishTranslator;


